module.exports = __webpack_public_path__ + "static/media/ar-logo.c94e341e.png";